import { IMainContext } from 'contexts/MainContext/MainContext.types';
import { TabletBreakpoint, MobileBreakpoint } from 'layout/Breakpoints';
import React, { useMemo } from 'react';

export const useViewport = (): IMainContext => {
    const [width, setWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleWindowResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    const mainContext = useMemo(() => {
        return {
            width,
            isDesktop: width > TabletBreakpoint,
            isTablet: TabletBreakpoint >= width && width > MobileBreakpoint,
            isMobile: MobileBreakpoint >= width
        };
    }, [width]);

    return mainContext;
};
